import { Row, Col } from 'antd';
import { motion } from "motion/react";

import Perfil from '../Perfil/Perfil';
import InfoUser from '../Perfil/InfoAcademica';
import Habilidades from '../Habilidades/Habilidades';
import Software from "../Software/Software";
import Idioma from "../Idioma/Idioma";
import ExpAcademica from '../ExpAcademica/ExpAcademica';
import ExpLaboral from '../ExpLaboral/ExpLaboral';
import EmpleosDisponibles from '../Postulaciones/EmpleosDisponibles';

const responsiveColProps = { xs: 24, sm: 24, md: 18, lg: 16, xl: 14 };


// Componente animado reutilizable
const AnimatedCard = ({ children, delay = 0 }) => (
  <motion.div
    initial={{ opacity: 0, y: 30 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: 30 }}
    transition={{ duration: 0.5, ease: "easeInOut", delay }}
  >
    {children}
  </motion.div>
);


const ModulosEgresados = () => {
  const hash = window.location.hash; // lectura directa


  const sections = [
    { component: <Perfil id="Inicio" />, delay: 0.2 },
    { component: <InfoUser id="Inicio" />, delay: 0.3 },
    { component: <Habilidades id="Habilidades" />, delay: 0.4 },
    { component: <Software id="Software" />, delay: 0.5 },
    { component: <Idioma id="Idiomas" />, delay: 0.6 },
    { component: <ExpAcademica id="ExperienciaAcademica" />, delay: 1 },
    { component: <ExpLaboral id="ExperienciaLaboral" />, delay: 1.2 },
    { component: <EmpleosDisponibles id="OfertaLaboral" />, delay: 1.4 },
  ];
  
  // Si la ruta actual es /postularce mostramos solo ese, sino los demás
  const filteredSections = hash === "#OfertaLaboral"
    ? sections.filter(({ component }) => component.props.id === "OfertaLaboral")
    : sections.filter(({ component }) => component.props.id !== "OfertaLaboral");

  return (
    <>
      <Row justify="center" gutter={[16, 16]}>
        {filteredSections.map(({ component, delay }, index) => (
          <Col key={index} {...responsiveColProps}>
            <AnimatedCard delay={delay}>{component}</AnimatedCard>
          </Col>
        ))}
      </Row>
    </>
  );
};

export default ModulosEgresados;